/* FB | Politika onay kutusu + "Satin Al" onay paneli PASIF (istek: hicbir sayfada gosterilmesin/kilitlemesin).
   ADDITIVE; calisan sepet/checkout akisini BOZMAZ. Buy-now paneli theme.liquid'deki erken
   window.__fbBuyConsentGate=true bayragiyla fb-buynow-consent.js'i no-op yapar. Burada sepet onay
   kutusu (#fb-consent-check + .fb-consent) DOM'dan kaldirilir ve required sokulur -> checkout direkt gecer. */
(function () {
  'use strict';
  if (window.__fbConsentOff) return; window.__fbConsentOff = true;
  function kill() {
    try {
      var c = document.getElementById('fb-consent-check');
      if (c) { try { c.removeAttribute('required'); } catch (e) {} try { c.checked = true; } catch (e2) {} }
    } catch (e) {}
    try {
      var ls = document.querySelectorAll('.fb-consent');
      for (var i = 0; i < ls.length; i++) { try { ls[i].remove(); } catch (e3) {} }
    } catch (e) {}
  }
  kill();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kill);
  window.addEventListener('load', kill);
  document.addEventListener('cart:update', function () { setTimeout(kill, 0); setTimeout(kill, 200); setTimeout(kill, 600); });
  try {
    var cd = document.querySelector('cart-drawer-component');
    if (cd) new MutationObserver(kill).observe(cd, { childList: true, subtree: true });
  } catch (e) {}
})();
